export const SliderData = [
    {
        image : 'https://ii1.pepperfry.com/media/wysiwyg/banners/Promo_Web_2X_04052022_nd-min.jpg'
    },
    {
        image : 'https://ii2.pepperfry.com/media/wysiwyg/banners/HB01_2X_22042022.jpg'
    },
    {
        image : 'https://ii3.pepperfry.com/media/wysiwyg/banners/HB02_2X_22042022.jpg'
    },
    {
        image : 'https://ii1.pepperfry.com/media/wysiwyg/banners/HB03_2X_22042022.jpg'
    }
];